import { combineReducers } from "redux";
import configsReducer from "./config-sessao/reducer";
import loginReducer from "./login/reducer";
import recuperarSenhaReducer from "./recuperarSenha/reducer";
import espelhoProducaoReducer from "./espelhoProducao/reducer";
import registrosBiometricosReducer from "./registrosBiometricos/reducer";
import previsaoProducaoReducer from "./previsaoProducao/reducer";
import extratoRepasseExternoReducer from "./extratoRepasseExterno/reducer";
import extratoRepasseExternoV2Reducer from "./extratoRepasseExternoV2/reducer";
import extratoRepasseReducer from "./extratoRepasse/reducer";
import demonstrativoFinanceiroReducer from "./demonstrativoFinanceiro/reducer";
import impostoRendaReducer from "./impostoRenda/reducer";
import preCadastroReducer from "./preCadastro/reducer";
import procedimentosReducer from "./procedimentoCooperado/reducer";
import documentosReducer from "./documentos/reducer";

const rootReducer = combineReducers({
  configsState: configsReducer,
  loginState: loginReducer,
  recuperarSenhaState: recuperarSenhaReducer,
  espelhoProducaoState: espelhoProducaoReducer,
  registrosBiometricosState: registrosBiometricosReducer,
  previsaoProducaoState: previsaoProducaoReducer,
  extratoRepasseExternoState: extratoRepasseExternoReducer,
  extratoRepasseExternoV2State: extratoRepasseExternoV2Reducer,
  extratoRepasseState: extratoRepasseReducer,
  demonstrativoFinanceiroState: demonstrativoFinanceiroReducer,
  impostoRendaState: impostoRendaReducer,
  preCadastroState: preCadastroReducer,
  procedimentosState: procedimentosReducer,
  documentosState: documentosReducer,
});

export default rootReducer;
